<template>
  <span v-if="hasClipboard">
    <q-icon name="las la-copy" @click="copy" :size="size || 'sm'" /> <q-tooltip no-parent-event v-model="tt">copied</q-tooltip>
  </span>
</template>

<script>

export default {
  name: 'CopyValue',
  props: ['value', 'size'],
  created () {
    if (!navigator.clipboard) {
      this.hasClipboard = false
    }
  },
  data () {
    return {
      tt: false,
      hasClipboard: true
    }
  },
  methods: {
    copy (event) {
      var vm = this
      var text = (vm.value || '').trim()
      try {
        navigator.clipboard.writeText(text)
        this.tt = true
        setTimeout(() => {
          vm.tt = false
        }, 2000)
      } catch (e) {
        console.log(e.message)
      }
    }
  }
}
</script>
